import PropTypes from "prop-types";
import React from "react";

import i18n from "@swa-ui/locale";
import { classNames } from "@swa-ui/string";

import { FirstNameFormField, firstNameFormFieldPropTypes } from "../FirstNameFormField";
import { LastNameFormField, lastNameFormFieldPropTypes } from "../LastNameFormField";
import { MiddleNameFormField, middleNameFormFieldPropTypes } from "../MiddleNameFormField";
import {
  PreferredFirstNameFormField,
  preferredFirstNameFormFieldPropTypes,
} from "../PreferredFirstNameFormField";
import { SuffixFormField, suffixFormFieldPropTypes } from "../SuffixFormField";
import styles from "./NameFormFields.module.scss";

/**
 * NameFormFields is combination of FirstName, MiddleName, LastName and Suffix formfield components.
 */
export const NameFormFields = (props) => {
  const {
    className,
    firstNameFormFieldProps = {},
    lastNameFormFieldProps = {},
    middleNameFormFieldProps = {
      description: i18n("NameFormField__OPTIONAL"),
    },
    preferredFirstNameFormFieldProps = {
      description: i18n("NameFormField__OPTIONAL"),
    },
    showPreferredFirstName = false,
    suffixFormFieldProps = {},
  } = props;

  return showPreferredFirstName ? renderNameFormFieldsWithPreferredName() : renderNameFormFields();

  function renderNameFormFields() {
    return (
      <div className={classNames(styles.formFieldsContainer, className)}>
        <FirstNameFormField {...firstNameFormFieldProps} />
        <MiddleNameFormField {...middleNameFormFieldProps} />
        <LastNameFormField {...lastNameFormFieldProps} />
        <SuffixFormField {...getSuffixFormFieldProps()} />
      </div>
    );
  }

  function renderNameFormFieldsWithPreferredName() {
    return (
      <div className={classNames(styles.containerWithPreferredName, className)}>
        <div className={classNames(styles.primaryNameRow)}>
          <FirstNameFormField {...firstNameFormFieldProps} />
          <MiddleNameFormField {...middleNameFormFieldProps} />
          <LastNameFormField {...lastNameFormFieldProps} />
        </div>
        <div className={classNames(styles.secondaryNameRow)}>
          <PreferredFirstNameFormField {...preferredFirstNameFormFieldProps} />
          <SuffixFormField {...getSuffixFormFieldProps()} />
        </div>
      </div>
    );
  }

  function getSuffixFormFieldProps() {
    return {
      description: i18n("NameFormField__OPTIONAL"),
      ...suffixFormFieldProps,
    };
  }
};

export const nameFormFieldsPropTypes = {
  /** Class name for positioning the component. */
  className: PropTypes.string,

  /** Component props for FirstNameFormField component. */
  firstNameFormFieldProps: PropTypes.shape(firstNameFormFieldPropTypes),

  /** Component props for LastNameFormField component. */
  lastNameFormFieldProps: PropTypes.shape(lastNameFormFieldPropTypes),

  /** Component props for MiddleFormField component. */
  middleNameFormFieldProps: PropTypes.shape(middleNameFormFieldPropTypes),

  /** Component props for PreferredFirstName component. */
  preferredFirstNameFormFieldProps: PropTypes.shape(preferredFirstNameFormFieldPropTypes),

  /** Indicates whether the PreferredFirstNameFormField should be rendered */
  showPreferredFirstName: PropTypes.bool,

  /** Component props for SuffixFormField component. */
  suffixFormFieldProps: PropTypes.shape(suffixFormFieldPropTypes),
};

NameFormFields.propTypes = nameFormFieldsPropTypes;
